var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wa-contact-list",
      class: { "wa-contact-list--mobile-full": _vm.mobileMode },
    },
    [
      _c("div", { staticClass: "wa-contact-list__header" }, [
        _c("div", { staticClass: "wa-contact-list__header-top" }, [
          _vm.selectedChannel
            ? _c("div", { staticClass: "wa-contact-list__channel-label" }, [
                _c("span", { staticClass: "wa-contact-list__channel-name" }, [
                  _vm._v(
                    _vm._s(
                      _vm.selectedChannel.name ||
                        _vm.$t("whatsappUi.defaultChannelName")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "wa-contact-list__channel-type" }, [
                  _vm._v(
                    _vm._s(_vm.getChannelTypeLabel(_vm.selectedChannel.type))
                  ),
                ]),
              ])
            : _c("span", { staticClass: "wa-contact-list__header-title" }, [
                _vm._v(_vm._s(_vm.$t("whatsappUi.defaultChannelName"))),
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "wa-contact-list__header-actions" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { content: _vm.$t("whatsappUi.newChatTooltip") },
                    expression: "{ content: $t('whatsappUi.newChatTooltip') }",
                  },
                ],
                staticClass: "wa-contact-list__icon-btn",
                on: {
                  click: function ($event) {
                    _vm.showNewConversationModal = true
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: "22",
                      height: "22",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h10M7 13h7",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.hideInbox
              ? _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { content: _vm.$t("whatsappUi.filterTooltip") },
                        expression:
                          "{ content: $t('whatsappUi.filterTooltip') }",
                      },
                    ],
                    staticClass: "wa-contact-list__icon-btn",
                    on: { click: _vm.toggleFilterPanel },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          viewBox: "0 0 24 24",
                          width: "22",
                          height: "22",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M3 4.5h18M7.5 10.5h9M10.5 16.5h3",
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wa-contact-list__search" }, [
          _c("div", { staticClass: "wa-contact-list__search-icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 24 24",
                  width: "18",
                  height: "18",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M11 3a8 8 0 100 16 8 8 0 000-16zM21 21l-4.35-4.35",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchQuery,
                expression: "searchQuery",
              },
            ],
            ref: "searchInput",
            staticClass: "wa-contact-list__search-input",
            attrs: { placeholder: _vm.$t("whatsappUi.searchPlaceholder") },
            domProps: { value: _vm.searchQuery },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchQuery = $event.target.value
                },
                _vm.onSearch,
              ],
              focus: function ($event) {
                _vm.searchFocused = true
              },
              blur: function ($event) {
                _vm.searchFocused = false
              },
            },
          }),
          _vm._v(" "),
          _vm.searchQuery
            ? _c(
                "button",
                {
                  staticClass: "wa-contact-list__search-clear",
                  on: { click: _vm.clearSearch },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 24 24",
                        width: "16",
                        height: "16",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M18 6L6 18M6 6l12 12",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.showFilterPanel && !_vm.hideInbox
          ? _c("div", { staticClass: "wa-contact-list__filters" }, [
              _c(
                "div",
                {
                  ref: "chipsWrap",
                  staticClass: "wa-contact-list__chips-wrap",
                  class: {
                    "wa-contact-list__chips-wrap--expanded":
                      _vm.filtersExpanded,
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "wa-contact-list__chip",
                      class: {
                        "wa-contact-list__chip--active":
                          _vm.activeChip === "all",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setChip("all")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("whatsappUi.chipAll")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "wa-contact-list__chip",
                      class: {
                        "wa-contact-list__chip--active":
                          _vm.activeChip === "unread",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setChip("unread")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("whatsappUi.chipUnread")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "wa-contact-list__chip",
                      class: {
                        "wa-contact-list__chip--active":
                          _vm.activeChip === "open",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setChip("open")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("whatsappUi.chipOpen")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "wa-contact-list__chip",
                      class: {
                        "wa-contact-list__chip--active":
                          _vm.activeChip === "closed",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setChip("closed")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("whatsappUi.chipClosed")))]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.customFilters, function (f) {
                    return _c(
                      "span",
                      {
                        key: f._id || f.id,
                        staticClass:
                          "wa-contact-list__chip wa-contact-list__chip--custom",
                        class: {
                          "wa-contact-list__chip--active":
                            _vm.activeChip === (f._id || f.id),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.setFilterChip(f)
                          },
                        },
                      },
                      [_vm._v(_vm._s(f.name))]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.showFilterToggle
                ? _c(
                    "button",
                    {
                      staticClass: "wa-contact-list__filter-toggle",
                      on: {
                        click: function ($event) {
                          _vm.filtersExpanded = !_vm.filtersExpanded
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.filtersExpanded
                              ? _vm.$t("whatsappUi.filterShowLess")
                              : _vm.$t("whatsappUi.filterShowMore")
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.showNewConversationModal
        ? _c(
            "Modal2",
            {
              attrs: {
                "show-footer": false,
                title: _vm.$t("whatsappUi.startChatModalTitle"),
              },
              on: {
                cancel: function ($event) {
                  _vm.showNewConversationModal = false
                  _vm.newConversationPhone = ""
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-phone-number": _vm.newConversationPhone,
                },
                on: {
                  close: function ($event) {
                    _vm.showNewConversationModal = false
                    _vm.newConversationPhone = ""
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "contactListBody",
          staticClass: "wa-contact-list__body",
          on: { scroll: _vm.onScroll },
        },
        [
          _vm.contacts.length > 0
            ? [
                _vm._l(_vm.contacts, function (contact) {
                  return _c("WAContactListItem", {
                    key: contact._id,
                    attrs: {
                      contact: contact,
                      "selected-contact": _vm.selectedContact,
                    },
                    on: { click: _vm.onContactClick },
                  })
                }),
                _vm._v(" "),
                _vm.loadingMore
                  ? _c(
                      "div",
                      { staticClass: "wa-contact-list__loading-more" },
                      [_vm._m(0)]
                    )
                  : _vm._e(),
              ]
            : _vm.loading
            ? _c(
                "div",
                { staticClass: "wa-contact-list__loading" },
                _vm._l(8, function (i) {
                  return _c(
                    "div",
                    { key: i, staticClass: "wa-contact-list__skeleton" },
                    [
                      _c("div", {
                        staticClass: "wa-contact-list__skeleton-avatar",
                      }),
                      _vm._v(" "),
                      _vm._m(1, true),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "wa-contact-list__empty" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: "40",
                      height: "40",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z",
                        fill: "#ccc",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("p", [_vm._v("Konuşma bulunamadı")]),
              ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "wa-contact-list__dot-loader" }, [
      _c("span"),
      _c("span"),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wa-contact-list__skeleton-content" }, [
      _c("div", { staticClass: "wa-contact-list__skeleton-name" }),
      _vm._v(" "),
      _c("div", { staticClass: "wa-contact-list__skeleton-msg" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }